// Project: GSSC Pilot Front-end
// Filename: api.js
// Copyright European Space Agency, 2020
// This file is part of the source code package for contract PO PO 5001024866
// No part of the package, including this file, may be copied, modified,
// propagated, or distributed without prior approval by ESA.
import axios from 'axios';
import store from '../store';
import mock from '@/mock/asset.list.json';
import https from 'https';

const http = axios.create({
  // withCredentials: true,
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 120000
});
// if (store.state.user !== "NO_HEADERS") { // Test only for no headers
//     console.log ('user is, ', store.state.user);
http.defaults.headers.common['SESSION-ID'] = store.state.token;
// }
// http.defaults.httpsAgent = new https.Agent({ rejectUnauthorized: false });

// Interceptors
const reqInterceptor = http.interceptors.request.use(config => {
  //on the fly can modify stuff ...
  console.log('Request Interceptor', config);
  return config;
});

// Compute some useful pagination information
function normalizePagination(pagination) {
  // convert from zero-based to one-based starting item
  // response params might be string
  const from = parseInt(pagination.from, 10) + 1;
  const size = parseInt(pagination.size, 10);
  // 10000 is the max number of assets set by the backend
  const BACKEND_MAX_ITEMS = 10000;
  return {
    // API returns from, size, total_count, order_by, sort_by
    ...pagination,
    current_page: Math.ceil(from / size),
    from,
    to: Math.min(from + size - 1, pagination.total_count),
    last_page: Math.min(
      Math.ceil(pagination.total_count / size),
      BACKEND_MAX_ITEMS / pagination.size
    )
  };
}

const errorCatcher = function(err) {
  console.log('errorcatcher is running');
  if (err.response) {
    console.log('errorCatcher data', err.response.data);
    console.log('errorCatcher status', err.response.status);
    if (err.response) {
      console.log('Response', err.response);
      // If status is Unauthorised --> Logout only, not redirect
      ///////////////needs to disable in dev mode ... //////////////////////////
      if (err.response.status) {
        console.log('Status', err.response.status);
        if (err.response.status === 401) {
          store.dispatch('logout');
          // window.location.href =
          //   process.env.VUE_APP_API_BASE_URL +
          //   '/user-management/login' +
          //   '?serviceurl=' +
          //   process.env.VUE_APP_ENTRY_URL;
          ////////////////////////
          // REDIRECT TO EXPLORER
          window.location.href = process.env.VUE_APP_ENTRY_URL;
          return 'no message';
        }
      }
      /////////////////////////////////////////

      // if (err.response.data) {
      //   return err.response.data;
      // } else {
      //   return err.response;
      // }
      return err.response;
    }
  }
};

const jwtReplacer = function(response) {
  if (response.headers) {
    if (
      response.headers.jwt &&
      response.headers.jwt != '' &&
      response.headers.jwt != '[object Object]'
    ) {
      console.log('LOGIN JWT', response);
      store.dispatch('renewToken', response.headers.jwt);
    }
  }
  return response;
};

export async function getAssets(params) {
  console.log('API-GETASSETS', params);
  // REDIRECT function needs session-id header to be set in the FIRST call to the api in each vue view that can be then the initial view.
  http.defaults.headers.common['SESSION-ID'] = store.state.token;
  try {
    // GET METHOD WILL BE DEPRECATED AND REPLACED BY POST
    // const response = await http.get('discovery-services/assets', { params }).then(jwtReplacer);
    const response = await http.post('discovery-services/assets', params).then(jwtReplacer);
    // console.log('HEADERS', response.headers);

    // const response = {
    //   data: mock,
    // };
    return {
      // aggregation, results, pagination
      ...response.data,
      pagination: normalizePagination(response.data.pagination)
    };
  } catch (err) {
    errorCatcher(err);
    return {
      error: `There was an error retrieving assets data from the backend: ${
        err.response && err.response.data
          ? err.response.status + ' -> ' + JSON.stringify(err.response.data.error.message)
          : err && err.message
          ? JSON.stringify(err.message)
          : JSON.stringify(err)
      }`
    };
  }
}
export async function getAssetsNoAggregations(params) {
  console.log('API-GETASSETS-NOAGGREGATIONS', params);
  // REDIRECT function needs session-id header to be set in the FIRST call to the api in each vue view that can be then the initial view.
  http.defaults.headers.common['SESSION-ID'] = store.state.token;
  try {
    // GET METHOD WILL BE DEPRECATED AND REPLACED BY POST
    // const response = await http.get('discovery-services/assets', { params }).then(jwtReplacer);
    const response = await http
      .post('discovery-services/assets/noaggregations', params)
      .then(jwtReplacer);
    // console.log('HEADERS', response.headers);

    // const response = {
    //   data: mock,
    // };
    return {
      // aggregation, results, pagination
      ...response.data,
      pagination: normalizePagination(response.data.pagination)
    };
  } catch (err) {
    errorCatcher(err);
    return {
      error: `There was an error retrieving assets data from the backend: ${
        err.response && err.response.data
          ? err.response.status + ' -> ' + JSON.stringify(err.response.data.error.message)
          : err && err.message
          ? JSON.stringify(err.message)
          : JSON.stringify(err)
      }`
    };
  }
}

export async function getStations(params) {
  console.log('getStations', params);
  // REDIRECT function needs session-id header to be set in the initial call to the api in each vue view that becomes then the initial view
  http.defaults.headers.common['SESSION-ID'] = store.state.token;

  // GET METHOD WILL BE DEPRECATED AND REPLACED BY POST
  // const response = await http
  //   .get('discovery-services/stations', { params })
  //   .then(jwtReplacer)
  //   .catch(errorCatcher);
  const response = await http
    .post('discovery-services/stations', params)
    .then(jwtReplacer)
    .catch(errorCatcher);

  return {
    // aggregation, results, pagination
    ...response.data,
    pagination: normalizePagination(response.data.pagination)
  };
}

export async function getDatasets(params) {
  // REDIRECT function needs session-id header to be set in the initial call to the api in each vue view that becomes then the initial view
  http.defaults.headers.common['SESSION-ID'] = store.state.token;
  // Requires user auth
  const response = await http
    .get('catalogue-services/datasets', {
      params: {
        ...params,
        session_id: store.state.token
      }
    })
    .then(jwtReplacer)
    .catch(errorCatcher);

  return {
    ...response.data,
    pagination: normalizePagination(response.data.pagination)
  };
}

export async function getResourceTypes(params) {
  // Requires user auth
  const response = await http
    .get('catalogue-services/resource-types', {
      params: {
        ...params,
        session_id: store.state.token
      }
    })
    .then(jwtReplacer)
    .catch(errorCatcher);
  return {
    ...response.data,
    pagination: normalizePagination(response.data.pagination)
  };
}
export async function getFileFormats(params) {
  // Requires user auth
  const response = await http
    .get('catalogue-services/file-format', {
      params: {
        ...params,
        session_id: store.state.token
      }
    })
    .then(jwtReplacer)
    .catch(errorCatcher);
  return {
    ...response.data,
    pagination: normalizePagination(response.data.pagination)
  };
}

// get elements for portal admin (aggregation-fields and column-fields)
export async function getElements(apiType, params) {
  // Requires user auth
  const response = await http
    .get(`portal-services/${apiType}`, {
      params: {
        ...params,
        session_id: store.state.token
      }
    })
    .then(jwtReplacer)
    .catch(errorCatcher);
  return {
    ...response.data,
    pagination: normalizePagination(response.data.pagination)
  };
}

export async function saveField(apiType, id, params) {
  // Requires user auth
  const response = await http
    .put(`portal-services/${apiType}/${id}`, {
      session_id: store.state.token,
      ...params
    })
    .then(jwtReplacer)
    .catch(errorCatcher);

  return response.data;
}

export async function addField(apiType, params) {
  // Requires user auth
  const response = await http
    .post(`portal-services/${apiType}`, {
      session_id: store.state.token,
      ...params
    })
    .then(jwtReplacer)
    .catch(errorCatcher);

  return response.data;
}

export async function deleteField(apiType, id) {
  // Requires user auth
  const response = await http
    .delete(`portal-services/${apiType}/${id}`, {
      session_id: store.state.token
    })
    .then(jwtReplacer)
    .catch(errorCatcher);

  return response.data;
}

// Get a link to download the given list of asset filenames
export async function getDownloadUrl(assets, searchParams, selectAll) {
  console.log('downloadAssets', assets);
  let assetIdArray = assets.map(e => Object.assign({ id: e['asset-id'] }));
  let bodyObject = {
    session_id: store.state.token,
    'manual-decompress': 'Yes',
    'filter-list': {
      'filter-engine': 'GSSC',
      search: searchParams,
      'select-all': selectAll,
      'asset-id': assetIdArray
    },
    'assets-list': assets
  };
  if (selectAll) {
    // If selectAll, no assets passed
    delete bodyObject['filter-list']['asset-id'];
    delete bodyObject['assets-list'];
  }
  try {
    const response = await http
      .post(
        'dissemination-services/assets',
        bodyObject,
        // {
        //   session_id: store.state.token,
        //   // {asset-id: 'abc', 'asset-location': 'path'}
        //   'assets-list': assets
        // },
        {
          responseType: 'text'
        }
      )
      .then(jwtReplacer);

    // URL of the download
    return response.data;
  } catch (err) {
    errorCatcher(err);
    return err.response.data;
  }
}

export async function getDownloadUrlSingle(assetId) {
  const response = await http
    .post(`dissemination-services/assets/${assetId}`, {
      responseType: 'text'
    })
    .then(jwtReplacer)
    .catch(errorCatcher);

  // URL of the download
  return response.data;
}

export async function downloadAssetSingle(assetId) {
  // Requires user auth
  try {
    console.log('download started');
    const response = await http
      .post(
        `dissemination-services/assets/${assetId}`,
        {
          session_id: store.state.token
        },
        { responseType: 'blob' }
      )
      .then(jwtReplacer);
    // console.log(response.headers);
    console.log('download finished');
    const contentDisposition = response.headers['content-disposition'];
    let filename = '';
    if (contentDisposition) {
      filename = contentDisposition
        .split(';')[1]
        .split('filename')[1]
        .split('=')[1]
        .trim();
    }
    return { filename: filename || 'file.ext', data: response.data };
  } catch (err) {
    console.log('err', err);
    return err.response.data;
  }
}

export async function getFileManagerUrl() {
  // Requires user auth
  const response = await http
    .post('analysis-services/instances', {
      // for testing just set arbitrary sessionid
      session_id: store.state.token,
      image: 'File Manager'
    })
    .then(jwtReplacer)
    .catch(errorCatcher);
  return response.data;
}

export async function pollAssetLabStatus(id) {
  try {
    const response = await http.get(`analysis-services/instances/${id}`, {
      params: {
        session_id: store.state.token
      }
    });
    return response.data;
  } catch (err) {
    console.log('err', err);
    return err.response.data.message;
  }
}
// GET VALID IMAGES FOR ASSETS
export async function getValidImagesAndInstances(assets, searchParams, selectAll, resourceTypes) {
  // Requires user auth
  let assetIdArray = assets.map(e => Object.assign({ id: e['asset-id'] }));
  let bodyObject = {
    session_id: store.state.token,
    'manual-decompress': 'Yes',
    'filter-list': {
      'filter-engine': 'GSSC',
      search: searchParams,
      'select-all': selectAll,
      'asset-id': assetIdArray
    },
    'assets-list': assets
  };
  bodyObject['filter-list'].search = bodyObject['filter-list'].search.concat(resourceTypes);
  console.log('getvalid', bodyObject);
  if (selectAll) {
    // If selectAll, no assets passed
    delete bodyObject['filter-list']['asset-id'];
    delete bodyObject['assets-list'];
  }
  try {
    const response = await http.post('analysis-services/instances', bodyObject).then(jwtReplacer);
    console.log('validstuff', response.data);
    return response.data;
  } catch (err) {
    console.log('err', err);
    errorCatcher(err);
    return err.response.data;
  }
}
// CREATES NEW LAB FROM ASSETS
export async function createLab(
  image,
  assets,
  assetIdArray,
  name,
  description,
  searchParams,
  selectAll
) {
  // Requires user auth
  // console.log('searchParams@API', searchParams);
  // console.log('assets@API', assets);
  // let assetIdArray = assets.map(e => Object.assign({ id: e['asset-id'] }));
  // console.log('assetidarray@API', assetIdArray);

  let bodyObject = {
    session_id: store.state.token,
    image,
    name,
    description,
    'manual-decompress': 'Yes',
    'filter-list': {
      'filter-engine': 'GSSC',
      search: searchParams,
      // search: [
      //   { size: "20" },
      //   { from: "0" },
      //   { query: "ESA" },
      //   { station: "ABMF" },
      //   { station: "AUTN" }
      // ],
      'select-all': selectAll,
      'asset-id': assetIdArray
      // "asset-id": [
      //   {
      //     id: "ABMF00GLP_R_20191400000_01D_30S_MO.rnx"
      //   }
      // ]
    },
    'assets-list': assets
  };
  if (selectAll) {
    // If selectAll, no assets passed
    delete bodyObject['filter-list']['asset-id'];
    delete bodyObject['assets-list'];
  }
  try {
    const response = await http.post('analysis-services/instances', bodyObject).then(jwtReplacer);
    console.log(' THIS IS DATA ', response.data);
    return response.data;
  } catch (err) {
    console.log('err', err);
    errorCatcher(err);
    return err.response.data;
  }
  // if (response.data) {
  //
  // } else if (response.message) {
  //   alert(response.message);
  // }
}

export async function openInLab(
  id,
  assets,
  assetIdArray,
  name,
  // description,
  searchParams,
  selectAll
) {
  let bodyObject = {
    session_id: store.state.token,
    name,
    // description,
    // 'manual-decompress': 'Yes',
    'filter-list': {
      'filter-engine': 'GSSC',
      search: searchParams,
      'select-all': selectAll,
      'asset-id': assetIdArray
    }
    // 'assets-list': assets
  };
  const response = await http
    .put(`analysis-services/instances/${id}`, bodyObject)
    .then(jwtReplacer)
    .catch(errorCatcher);

  return response.data;
}

//LABS functions
export async function getSavedLabs(params) {
  // REDIRECT function needs session-id header to be set in the initial call to the api in each vue view that becomes then the initial view
  http.defaults.headers.common['SESSION-ID'] = store.state.token;
  // Requires user auth
  const response = await http
    .get('analysis-services/instances', {
      params: {
        ...params,
        session_id: store.state.token
      }
    })
    .then(jwtReplacer)
    .catch(errorCatcher);
  return response.data;
}

export async function deleteLab(id) {
  // Requires user auth
  const response = await http
    .delete(`analysis-services/instances/${id}`, {
      params: {
        session_id: store.state.token
      }
    })
    .then(jwtReplacer)
    .catch(errorCatcher);

  return response.data;
}

export async function startLab(id) {
  // Requires user auth
  const response = await http
    .post(`analysis-services/instances/${id}/start`, {
      session_id: store.state.token
    })
    .then(jwtReplacer)
    .catch(errorCatcher);

  return response.data;
}

export async function stopLab(id) {
  // Requires user auth
  const response = await http
    .post(`analysis-services/instances/${id}/stop`, {
      session_id: store.state.token
    })
    .then(jwtReplacer)
    .catch(errorCatcher);

  return response.data;
}

export async function saveLab(id, name, description) {
  // Requires user auth
  const response = await http
    .put(`analysis-services/instances/${id}`, {
      session_id: store.state.token,
      name,
      description
    })
    .then(jwtReplacer)
    .catch(errorCatcher);

  return response.data;
}

export async function getSavedFilters(params) {
  // REDIRECT function needs session-id header to be set in the initial call to the api in each vue view that becomes then the initial view
  http.defaults.headers.common['SESSION-ID'] = store.state.token;
  // Requires user auth
  const response = await http
    .get('user-management/filters', {
      params: {
        ...params,
        session_id: store.state.token
      }
    })
    .then(jwtReplacer)
    .catch(errorCatcher);
  return response.data;
}

export async function saveFilter(name, description, searchQuery) {
  // Requires user auth
  // console.log(searchQuery);
  const response = await http
    .post('user-management/filters', {
      session_id: store.state.token,
      name,
      description,
      'manual-decompress': 'Yes',
      'filter-list': {
        search: searchQuery
      },
      'filter-engine': 'GSSC'
    })
    .then(jwtReplacer)
    .catch(errorCatcher);
  return response.data;
}

export async function editFilter(id, name, description) {
  // Requires user auth
  const response = await http
    .put(`user-management/filters/${id}`, {
      session_id: store.state.token,
      name,
      description
    })
    .then(jwtReplacer)
    .catch(errorCatcher);

  return response.data;
}

export async function deleteFilter(id) {
  // Requires user auth
  const response = await http
    .delete(`user-management/filters/${id}`, {
      params: {
        session_id: store.state.token
      }
    })
    .then(jwtReplacer)
    .catch(errorCatcher);

  return response.data;
}

export async function downloadCsvAssets(searchParams, selectAll, assets) {
  // Requires user auth
  let assetIdArray = assets.map(e => Object.assign({ id: e['asset-id'] }));
  let bodyObject = {
    session_id: store.state.token,
    'manual-decompress': 'Yes',
    'filter-list': {
      'filter-engine': 'GSSC',
      search: searchParams,
      'select-all': selectAll,
      'asset-id': assetIdArray
    },
    'assets-list': assets
  };
  // console.log('bodyObject', bodyObject);
  if (selectAll) {
    // If selectAll, no assets passed
    delete bodyObject['filter-list']['asset-id'];
    delete bodyObject['assets-list'];
  }
  // const response = await http
  //   .post('dissemination-services/csv/assets', bodyObject)
  //   .then(jwtReplacer)
  //   .catch(errorCatcher);
  try {
    const response = await http
      .post(
        'dissemination-services/csv/assets',
        bodyObject
        //  {
        //   session_id: "gssc_superuser",
        //   "manual-decompress": "Yes",
        //   "filter-list": {
        //     search: searchQuery,
        //     "select-all": true
        //   },
        //   "filter-engine": "GSSC"
        // }
      )
      .then(jwtReplacer);
    console.log('THIS IS DATA', response);
    return response;
  } catch (err) {
    console.log('THIS IS ERROR', err.response);
    console.log('err', err);
    return err.response.data;
    // return err.response.data;
  }
}

export async function downloadCsv(filetype) {
  // Requires user auth
  try {
    const response = await http
      .post(`dissemination-services/csv/${filetype}`, {
        session_id: store.state.token
      })
      .then(jwtReplacer);
    return response.data;
  } catch (err) {
    console.log('err', err);
    // return err.response.data;
  }
}
export async function sync(limit) {
  const response = await http
    .post('catalogue-services/sync', {
      session_id: store.state.token,
      files_limit: limit
    })
    .then(jwtReplacer)
    .catch(errorCatcher);
  return response.data;
}

export async function signin(username, password) {
  const response = await http
    .post('/user-management/login', {
      username,
      password
    })
    .then(response => {
      return response;
    })
    .catch(errorCatcher);
  return response.data;
}

export async function login(ticket) {
  try {
    const response = await http
      .get('/user-management/login', {
        // transformRequest: (data, headers) => {
        //   delete headers.common['SESSION-ID'];
        // },
        params: {
          ticket, //"ST-1769-ieIf3QYJIy0j70wTV2cE-01"
          serviceurl: process.env.VUE_APP_ENTRY_URL
        }
      })
      .then(jwtReplacer);
    // console.log('RESPONSE LOGIN', response);
    return response.data;
  } catch (err) {
    console.log('err', err.response);
    return err.response.status + ' ' + err.response.data;
  }
}

export async function logout() {
  http.defaults.headers.common['SESSION-ID'] = store.state.token;
  try {
    const response = await http.get('/user-management/logout', {
      params: {
        serviceurl: 'https://gssc.ideorum.com' //process.env.VUE_APP_ENTRY_URL
      }
    });
    console.log('RESPONSE LOGOUT', response);
    return response.data;
  } catch (err) {
    console.log('err', JSON.stringify(err));
    return 'err'; //err.response.status + ' ' + err.response.data;
  }
}

export async function createNewElement(apiType, formItems) {
  // console.log('formitems', formItems);
  try {
    const response = await http
      .post(`catalogue-services/${apiType}`, {
        session_id: store.state.token,
        ...formItems
      })
      .then(jwtReplacer);
    return response.data;
  } catch (err) {
    console.log('err', err.response.data);
    return { error: err.response.data };
  }
}

export async function editElement(apiType, id, formItems) {
  try {
    // console.log('formitems', formItems);
    const response = await http
      .put(`catalogue-services/${apiType}/${id}`, {
        session_id: store.state.token,
        ...formItems
      })
      .then(jwtReplacer);
    // console.log('RESPONSE IS', response);
    return response.data;
  } catch (err) {
    console.log('err', err.response.data);
    return { error: err.response.data };
  }
}

export async function deleteElement(apiType, id) {
  try {
    const response = await http
      .delete(`catalogue-services/${apiType}/${id}`, {
        data: {
          session_id: store.state.token
        }
      })
      .then(jwtReplacer);
    return response.data;
  } catch (err) {
    console.log('err', err);
    // return err.response;
  }
}

export async function getQuota() {
  try {
    const response = await http
      .get('user-management/users/quotas', {
        params: {
          session_id: store.state.token
        }
      })
      .then(jwtReplacer);
    return response.data;
  } catch (err) {
    console.log('err', err);
    errorCatcher(err);
  }
}

export async function getAutocompleteOptions(text) {
  try {
    const response = await http
      .get('catalogue-services/autocomplete-dictionary', {
        params: {
          // session_id: store.state.token,
          text
        }
      })
      .then(jwtReplacer);
    return response.data;
  } catch (err) {
    console.log('err', err);
    errorCatcher(err);
  }
}

export async function getBanners() {
  try {
    const response = await http
      .get('portal-services/announcement-banners', {
        params: {
          session_id: store.state.token,
          order_by: 'DESC',
          from: 0,
          sort_by: 'announcement_id'
        }
      })
      .then(jwtReplacer);
    return response.data;
  } catch (err) {
    console.log('err', err);
    errorCatcher(err);
  }
}

export async function createBanner(params) {
  // console.log('formitems', formItems);
  try {
    const response = await http
      .post('portal-services/announcement-banners', {
        session_id: store.state.token,
        ...params
      })
      .then(jwtReplacer);
    return response.data;
  } catch (err) {
    console.log('err', err.response.data);
    return { error: err.response.data };
  }
}

export async function saveBanner(id, params) {
  // Requires user auth
  const response = await http
    .put(`portal-services/announcement-banners/${id}`, {
      session_id: store.state.token,
      ...params
    })
    .then(jwtReplacer)
    .catch(errorCatcher);

  return response.data;
}

export async function deleteBanner(id) {
  try {
    const response = await http
      .delete(`portal-services/announcement-banners/${id}`, {
        data: {
          session_id: store.state.token
        }
      })
      .then(jwtReplacer);
    return response.data;
  } catch (err) {
    console.log('err', err);
    errorCatcher(err);
  }
}

export async function uploadPicture(file, id, onUploadProgress, dataTypePath) {
  let formData = new FormData();
  formData.append('picture', file);
  formData.append('session_id', store.state.token);
  const response = await http.put(`/catalogue-services/${dataTypePath}/${id}/picture`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress
  });
  return response.data;
}

export async function uploadAsset(files, path, datasetId, onUploadProgress) {
  let formData = new FormData();
  files.forEach(file => {
    formData.append('file', file);
  });
  formData.append('path', path);
  formData.append('dataset_id', datasetId);
  formData.append('session_id', store.state.token);

  const response = await http
    .post(`/ingestion-services/assets`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress
    })
    .catch(errorCatcher);
  return response.data;
}

export async function getAbout() {
  try {
    const response = await http
      .get('portal-services/about-page', {
        params: {
          session_id: store.state.token
        }
      })
      .then(jwtReplacer);
    return response.data;
  } catch (err) {
    console.log('err', err);
    errorCatcher(err);
  }
}

export async function saveAbout(params) {
  // console.log('formitems', formItems);
  try {
    console.log(params);
    const response = await http
      .post('portal-services/about-page', {
        session_id: store.state.token,
        ...params
      })
      .then(jwtReplacer);
    return response.data;
  } catch (err) {
    console.log('err', err.response.data);
    return { error: err.response.data };
  }
}
